export const fillSelect = (sel, options) => {
  var def
  sel.options.length = 0
  var i = 0
  options.forEach(opt => {
    if (opt.isDefault) def = opt.id
    sel.options[i] = new Option(opt.name || opt.text, opt.id)
    i++
  })
  if (def) sel.value = def
}
